/* Goldwort Noir – Interaktionen für die .gw-Sections.
   Läuft ohne Bibliotheken. Jede Funktion arbeitet nur innerhalb ihrer Section,
   damit der Theme-Editor Sections einzeln neu laden kann. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  document.documentElement.classList.add('js-gw');

  /* ---------- Scroll-Fortschritt ---------- */
  function initProgress() {
    if (document.querySelector('.gw-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'gw-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--gw-scroll', max > 0 ? Math.min(window.scrollY / max, 1) : 0);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Einblenden beim Scrollen (Fallback) ---------- */
  var revealObserver = null;
  function initReveal(root) {
    var items = root.querySelectorAll('.gw-rise');
    if (supportsTimeline || reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
    }
    items.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- 3D-Buch ---------- */
  function initBook(root) {
    var stage = root.querySelector('[data-gw-stage]');
    if (!stage) return;
    var book = stage.querySelector('.gw-book');
    var cover = stage.querySelector('.gw-cover');
    var px = 0, py = 0;
    function setBook() {
      var s = Math.min(window.scrollY / 500, 1);
      var ry = -28 + s * 28 + px * 18;
      var rx = -8 + py * -10;
      book.style.setProperty('--ry', ry + 'deg');
      book.style.setProperty('--rx', rx + 'deg');
      cover.style.setProperty('--glare', (-60 + (ry + 30) * 3) + '%');
    }
    if (!reduce) {
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        px = (e.clientX - r.left) / r.width - 0.5;
        py = (e.clientY - r.top) / r.height - 0.5;
        setBook();
      });
      stage.addEventListener('pointerleave', function () { px = py = 0; setBook(); });
      window.addEventListener('scroll', setBook, { passive: true });
    }
    setBook();
  }

  /* ---------- Statement: Wörter leuchten auf ---------- */
  function initStatement(root) {
    var st = root.querySelector('[data-gw-statement]');
    if (!st || st.dataset.ready) return;
    st.dataset.ready = '1';
    var text = st.textContent.trim().replace(/\s+/g, ' ');
    st.textContent = '';
    text.split(' ').forEach(function (word, i) {
      if (i) st.appendChild(document.createTextNode(' '));
      var span = document.createElement('span');
      span.className = 'w';
      span.textContent = word;
      st.appendChild(span);
    });
    var words = st.querySelectorAll('.w');
    function light() {
      var r = st.getBoundingClientRect(), vh = window.innerHeight;
      var p = reduce ? 1 : Math.min(Math.max((vh * 0.85 - r.top) / (r.height + vh * 0.35), 0), 1);
      var n = Math.round(p * words.length);
      words.forEach(function (w, i) { w.classList.toggle('on', i < n); });
    }
    window.addEventListener('scroll', light, { passive: true });
    light();
  }

  /* ---------- Kapitel: Licht folgt der Maus ---------- */
  function initSpotlight(root) {
    root.querySelectorAll('.gw-ch').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---------- Selbstwert-Check ---------- */
  function initCheck(root) {
    var box = root.querySelector('[data-gw-check]');
    if (!box) return;
    var labels = ['Nie', 'Selten', 'Manchmal', 'Oft', 'Fast immer'];
    var inputs = Array.prototype.slice.call(box.querySelectorAll('input[type=range]'));
    var cfg = JSON.parse(box.querySelector('[data-gw-check-config]').textContent);
    var canvas = box.querySelector('.gw-chart');
    var total = box.querySelector('[data-out=total]');
    var type = box.querySelector('[data-out=type]');
    var desc = box.querySelector('[data-out=desc]');
    var meter = box.querySelector('[data-out=meter]');
    var tips = box.querySelector('[data-out=tips]');
    var tipsWrap = box.querySelector('[data-out=tipswrap]');

    function fill(el) {
      el.style.setProperty('--p', ((el.value - el.min) / (el.max - el.min) * 100) + '%');
    }

    function draw(values) {
      if (!canvas) return;
      var dpr = window.devicePixelRatio || 1;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      var c = canvas.getContext('2d');
      c.scale(dpr, dpr);
      c.clearRect(0, 0, w, h);
      var css = getComputedStyle(document.documentElement);
      var gold = css.getPropertyValue('--gw-gold').trim() || '#d9b46a';
      var muted = css.getPropertyValue('--gw-muted').trim() || '#9a978f';
      var line = css.getPropertyValue('--gw-line').trim() || '#26262c';
      var n = values.length;
      var rowH = h / n;
      var labelW = Math.min(150, w * 0.42);
      c.font = '500 13px Figtree, system-ui, sans-serif';
      c.textBaseline = 'middle';
      values.forEach(function (v, i) {
        var y = i * rowH + rowH / 2;
        var barW = w - labelW - 8;
        c.fillStyle = muted;
        var label = inputs[i].dataset.short || '';
        c.fillText(label.length > 20 ? label.slice(0, 19) + '…' : label, 0, y);
        c.fillStyle = line;
        roundRect(c, labelW, y - 5, barW, 10, 5);
        c.fill();
        if (v > 0) {
          c.fillStyle = gold;
          roundRect(c, labelW, y - 5, Math.max(barW * v / 4, 10), 10, 5);
          c.fill();
        }
      });
    }

    function roundRect(c, x, y, w, h, r) {
      c.beginPath();
      c.moveTo(x + r, y);
      c.arcTo(x + w, y, x + w, y + h, r);
      c.arcTo(x + w, y + h, x, y + h, r);
      c.arcTo(x, y + h, x, y, r);
      c.arcTo(x, y, x + w, y, r);
      c.closePath();
    }

    function calc() {
      var values = inputs.map(function (el) {
        fill(el);
        var v = +el.value;
        var out = box.querySelector('[data-label-for="' + el.id + '"]');
        if (out) out.textContent = labels[v];
        return v;
      });
      var score = Math.round(values.reduce(function (a, b) { return a + b; }, 0) / (values.length * 4) * 100);
      total.textContent = score + ' %';
      meter.style.setProperty('--v', score + '%');
      var level = score <= 33 ? cfg.low : (score <= 66 ? cfg.mid : cfg.high);
      type.textContent = level.title;
      desc.textContent = level.text;

      var ranked = inputs.map(function (el, i) { return { v: values[i], tip: el.dataset.tip }; })
        .filter(function (x) { return x.v >= 2 && x.tip; })
        .sort(function (a, b) { return b.v - a.v; })
        .slice(0, 3);
      tips.textContent = '';
      ranked.forEach(function (x) {
        var li = document.createElement('li');
        li.textContent = x.tip;
        tips.appendChild(li);
      });
      tipsWrap.hidden = ranked.length === 0;
      draw(values);
    }

    inputs.forEach(function (el) { el.addEventListener('input', calc); });
    window.addEventListener('resize', calc);
    calc();
  }

  /* ---------- 30-Tage-Plan: Linie füllt sich ---------- */
  function initSteps(root) {
    var steps = root.querySelector('[data-gw-steps]');
    if (!steps) return;
    function update() {
      var r = steps.getBoundingClientRect(), vh = window.innerHeight;
      var p = reduce ? 1 : Math.min(Math.max((vh * 0.8 - r.top) / (r.height + vh * 0.2), 0), 1);
      steps.style.setProperty('--fill', p.toFixed(3));
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Sticky-Kaufleiste ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-gw-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('[data-gw-hero]');
    var buy = document.querySelector('[data-gw-buy]');
    var footer = document.querySelector('footer');
    var state = { hero: true, buy: false, footer: false };
    function render() {
      bar.classList.toggle('is-visible', !state.hero && !state.buy && !state.footer);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === hero) state.hero = e.isIntersecting;
        if (e.target === buy) state.buy = e.isIntersecting;
        if (e.target === footer) state.footer = e.isIntersecting;
      });
      render();
    });
    if (hero) io.observe(hero); else state.hero = false;
    if (buy) io.observe(buy);
    if (footer) io.observe(footer);
    render();
  }

  function initSection(root) {
    initReveal(root);
    initBook(root);
    initStatement(root);
    initSpotlight(root);
    initCheck(root);
    initSteps(root);
  }

  function start() {
    initProgress();
    initSection(document);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Theme-Editor: neu geladene Sections wieder aktivieren */
  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target);
    initSticky();
  });
})();
